var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33464 26.6693C4.6013 26.6693 3.97375 26.4084 3.45197 25.8866C2.93019 25.3648 2.66886 24.7368 2.66797 24.0026V8.0026C2.66797 7.26927 2.9293 6.64172 3.45197 6.11994C3.97464 5.59816 4.60219 5.33683 5.33464 5.33594H13.3346L16.0013 8.0026H26.668C27.4013 8.0026 28.0293 8.26394 28.552 8.7866C29.0746 9.30927 29.3355 9.93683 29.3346 10.6693H14.9013L12.2346 8.0026H5.33464V24.0026L8.53464 13.3359H31.3346L27.9013 24.7693C27.7235 25.347 27.396 25.8084 26.9186 26.1533C26.4413 26.4982 25.9133 26.6702 25.3346 26.6693H5.33464ZM8.13463 24.0026H25.3346L27.7346 16.0026H10.5346L8.13463 24.0026Z",
    fill: "#013A28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c2e04d2308beae106e66e6d9e428e291.svg";
export { ForwardRef as ReactComponent };